import { Injectable } from '@angular/core';
import { CommonService } from '../services/common.service'
import { AuthenticationService } from '../services/authentication.service'
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {

    constructor(private http: HttpClient, private common: CommonService, private authentication: AuthenticationService) { }

    
    submitAuthContactUs(obj: any) {
        var response = this.http.post(this.common.apiServiceURL + 'ContactUs/submitAuthContactUs', obj);
        return response;
    }
}
